import { render, staticRenderFns } from "./_activityId.vue?vue&type=template&id=568d30ca&scoped=true&"
import script from "./_activityId.vue?vue&type=script&lang=js&"
export * from "./_activityId.vue?vue&type=script&lang=js&"
import style0 from "./_activityId.vue?vue&type=style&index=0&id=568d30ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568d30ca",
  null
  
)

export default component.exports